// import React from 'react'
// import clsx from "clsx"

// export default function Input({ icon, rightIcon, className,as = "input",children, ...props}) {
// 	const input = 
// 		<input 
// 			type="text" 
// 			className={clsx(
// 				"w-full min-w-56 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg p-2", 
// 				"focus:(outline-none ring ring-gray-300)",
// 				icon && "pl-10",
// 				props.disabled && "!text-gray-600 !bg-gray-200",
// 				className,
// 			)}
// 			{...props}
// 		/>

// 	if (icon) {
// 		return (
// 		<div className="w-full flex items-center relative mx-0 md:mx-3">
// 		  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-600">
// 		    {icon}
// 		  </div>
// 		  {input}
// 		  <div className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-600">
//           {rightIcon}
//         </div>
// 		</div>
// 		)
// 	} else {
// 		return input
// 	}
// }


import React from "react";
import clsx from "clsx";

export default function Input({
  icon,
  rightIcon,
  className,
  as = "input",
  children,
  ...props
}) {
  const baseClasses = clsx(
    "w-full min-w-56 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg p-2",
    "focus:(outline-none ring ring-gray-300)",
    icon && "pl-10",
    rightIcon && "pr-10",
    props.disabled && "!text-gray-600 !bg-gray-200",
    className
  );

  const field =
    as === "select" ? (
      <select className={baseClasses} {...props}>
        {children}
      </select>
    ) : (
      <input className={baseClasses} {...props} />
    );

  if (icon || rightIcon) {
    return (
      <div className="w-full flex items-center relative mx-0 md:mx-3">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-600">
            {icon}
          </div>
        )}

        {field}

        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-gray-600">
            {rightIcon}
          </div>
        )}
      </div>
    );
  }

  return field;
}
